import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonDirective,
  DividerComponent,
  RadioButtonDirective
} from '@com-delta-omnichannel/aura';

import { Checkout } from '../checkout/models/checkout.interfaces';
import {
  Membership,
  MembershipDetails,
  Purchase
} from './models/purchase-options.interfaces';

@Component({
  selector: 'idp-purchase-options',
  standalone: true,
  imports: [
    RadioButtonDirective,
    ButtonDirective,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    DividerComponent
  ],
  templateUrl: './purchase-options.component.html',
  styleUrls: ['./purchase-options.component.scss']
})
export class PurchaseOptionsComponent {
  @Input() content!: Purchase;
  @Input() checkout!: Checkout;
  @Output() addToCart: EventEmitter<Membership> =
    new EventEmitter<Membership>();

  membership: Membership = {} as Membership;

  selectOptions(value: string, detail: MembershipDetails) {
    this.membership = {
      value,
      selected: true,
      detail: detail
    };
  }

  onAddToCartClick() {
    this.addToCart.emit(this.membership);
  }
}
